<template>
  <button class="power-btn" :class="{ active: isActive }" @click="toggle">
    <svg viewBox="0 0 24 24" class="icon">
      <path
        d="M12 2v10M5.5 6.5a8 8 0 1 0 13 0"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: "PowerButton",
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggle() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
.power-btn {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(12px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3),
    inset 0 2px 4px rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.6);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
}

.power-btn:hover {
  box-shadow: 0 0 15px rgba(0, 255, 150, 0.3),
    inset 0 0 6px rgba(255, 255, 255, 0.2);
}

.power-btn.active {
  color: #00ff9d;
  box-shadow: 0 0 25px rgba(0, 255, 150, 0.6),
    inset 0 0 10px rgba(0, 255, 150, 0.4);
  animation: pulse 2s infinite ease-in-out;
}

.icon {
  width: 65px;
  height: 65px;
  transition: transform 0.3s;
}

.power-btn.active .icon {
  transform: scale(1.1);
}

@keyframes pulse {
  0%,
  100% {
    box-shadow: 0 0 20px rgba(0, 255, 150, 0.4),
      inset 0 0 10px rgba(0, 255, 150, 0.3);
  }
  50% {
    box-shadow: 0 0 35px rgba(0, 255, 150, 0.8),
      inset 0 0 15px rgba(0, 255, 150, 0.6);
  }
}
</style>
